import React from "react";
import { AssessmentViewV2 } from "./v2";

export const AssessmentView = (): JSX.Element => <AssessmentViewV2 />;
